import styled from 'styled-components/macro';
import { fonts, mediaQuery, colours } from '@noths/styles-config';
import { fixedWidthContent } from '../../styles';

// TODO: Extract to @noths/styles-config
colours.veniceBlue = '#056582';

export const Heading = styled.h1`
  ${fixedWidthContent}
  color: ${colours.veniceBlue};
  font-size: ${fonts.size.xxl};
  text-transform: uppercase;
  font-weight: normal;
  margin-bottom: 10px;

  ${mediaQuery('tablet desktop')} {
    font-size: ${fonts.size.xxxl};
  }
`;
